import { makeStyles, mergeClasses } from '@griffel/react';

import { AppLayoutBreakpoint } from '../../../../util/responsiveness';
import { HighContrastEmulationClassName } from '../../../../util/styles/highContrastEmulation';

interface Props {
  readonly hasHeroBackground: boolean;
  readonly containerWidth: number;
}

type UseClassName = (props: Props) => string;
export const useClassName: UseClassName = ({ hasHeroBackground, containerWidth }) => {
  const classNames = useHeroBackgroundClasses();
  const shouldShowHeroBackgroundAtCurrentBreakpoint = containerWidth >= AppLayoutBreakpoint.Width812;
  const shouldShowHeroBackground = hasHeroBackground && shouldShowHeroBackgroundAtCurrentBreakpoint;

  return mergeClasses(shouldShowHeroBackground && classNames.root, 'qaMainAreaRowContent');
};

const useHeroBackgroundClasses = makeStyles({
  root: {
    [`:global(.${HighContrastEmulationClassName})`]: {
      backgroundImage: 'none',
    },
  },
});
